module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/isologotipo_b_una_tinta-b456b657e38e4b5f62f4b7b34d6ac0ad.svg";